import {
  NoAccessContainer,
  NoAccessDesc,
  NoAccessTitle,
} from './NotFoundStyles';

export const NotFound = () => {
  return (
    <NoAccessContainer>
      <NoAccessTitle>Page Not Found</NoAccessTitle>
      <NoAccessDesc>
        The requested URL was not found on this server.
      </NoAccessDesc>

      <NoAccessDesc>
        <a href='/'>Go Home</a>
      </NoAccessDesc>
    </NoAccessContainer>
  );
};
